

















import gql from 'graphql-tag';
import Vue from 'vue';

interface Client {
  id: string;
  name: string;
  country: string;
}

const query = gql`
  query($clientId: ID!) {
    projects: listProject(client: $clientId) {
      id
      name
    }
  }
`;

export default Vue.extend({
  props: {
    clientId: {
      type: String as () => string | undefined,
    },
    value: {
      type: String as () => string,
    },
  },

  data() {
    return {
      projects: [],
    };
  },

  apollo: {
    projects: {
      query,
      variables() {
        return {
          clientId: this.clientId,
        };
      },
      skip() {
        return !this.clientId;
      },
      fetchPolicy: 'cache-first',
    },
  },

  methods: {
    filterOption(input: any, option: any) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    onChange(val: string) {
      this.$emit('change', val);
      this.$emit('input', val);
    },
  },
});
